<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  
  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" id="myTab" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link active w-100" id="rollovers-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
        role="tab" aria-controls="home" aria-selected="true">
        Rollovers
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" id="credit-requests-tab" data-bs-toggle="tab" data-bs-target="#profile"
        type="button" role="tab" aria-controls="profile" aria-selected="false">
        Rollover Requests
        <span class="badge bg-danger ms-1">
          {{rolloverRequests.length}}
        </span>
      </button>
    </li>
  </ul>

  <!-- Tab Contents -->
  <div class="tab-content mt-3" id="myTabContent">

    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="rollovers-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
            <div class="d-flex align-items-center gap-2 flex-nowrap">
          
              <!-- Search input -->
              <div class="position-relative flex-grow-1 min-width-0">
                <input id="searchUser" type="text" class="form-control user-search-input shadow-none" placeholder="Type here..."
                  [(ngModel)]="searchText" (input)="performSearch()" />
          
                <span class="search-icon" (click)="performSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
          
              <!-- Advanced Filter -->
              <div class="flex-shrink-0 advanced-filter-wrapper">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                  (filterApplied)="onFilter($event)" (filterCleared)="onClear()">
                </app-filter-panel>
              </div>
          
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isLoadingRollovers" class="text-muted">Loading rollovers...</div>

          <!-- Table -->
          <div *ngIf="filteredRollovers.length > 0 && !errorRollovers" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">CIXOR Ref. Number</th>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-end">Total Due Amount</th>
                  <th class="table-title text-end">Roll Over Amount</th>
                  <th class="table-title text-end">Non Roll Over Amount</th>
                  <th class="table-title text-end">Roll Over Fee</th>
                  <th class="table-title text-center">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rollover of pagedRollovers">
                  <td class="table-data-text text-start">{{ rollover.cixorReferenceNumber }}</td>
                  <td class="table-data-text text-start">{{ rollover.companyName }}</td>
                  <td class="table-data-text text-end">{{ rollover.totalDueAmount | currency:'LKR ':'symbol':'1.2-2' }}
                  </td>
                  <td class="table-data-text text-end">{{ rollover.rollOverAmount | currency:'LKR ':'symbol':'1.2-2' }}
                  </td>
                  <td class="table-data-text text-end">{{ rollover.nonRollOverAmount | currency:'LKR ':'symbol':'1.2-2'
                    }}</td>
                  <td class="table-data-text text-end">{{ rollover.rollOverFeeAmount | currency:'LKR ':'symbol':'1.2-2'
                    }}</td>
                  <td class="table-data-text text-center">
                    <!-- Rollovers table action button - REMOVED data-bs attributes -->
                    <button class="btn p-0" style="background: none; border: none;"
                      (click)="openRolloverProfile(rollover.companyRollOverId)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <!-- <app-paginator [dataSource]="filteredRollovers" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onRolloverPageChange($event)">
            </app-paginator> -->
            <app-paginator [serverSide]="true" [totalItems]="totalRollovers" [pageSize]="rolloverPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onRolloverPageChange($event)">
            </app-paginator>

          </div>

          <!-- Empty State -->
          <div *ngIf="(filteredRollovers.length === 0 || errorRollovers) && !isLoadingRollovers" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Rollovers Found.</p>
          </div>

        </div>
      </div>
    </div>

    <!--==============================================================================================================-->


    <!-- Rollover Requests -->
    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="credit-requests-tab">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3 mt-3">

            <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
              <div class="position-relative">
                <input id="searchUser" type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="searchRolloverRequestsText" (input)="performSearch()" />
                <span class="search-icon" (click)="performSearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="isLoadingRequests" class="text-muted">Loading rollover requests...</div>
          <!-- Empty State -->
          <div *ngIf="(filteredRolloverRequests.length === 0 || errorRequests) && !isLoadingRequests" class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">No Rollover Requests Found.</p>
          </div>

          <div *ngIf="filteredRolloverRequests.length > 0 && !errorRequests" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start">Date Received</th>
                  <th class="table-title text-start">Client Name</th>
                  <th class="table-title text-start">CSM</th>
                  <th class="table-title text-start">Rollover Limit</th>
                  <th class="table-title text-start">Rollover Days</th>
                  <th class="table-title text-center">
                    <i class="bi bi-eye"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let request of pagedRolloverRequests">
                  <td class="table-data-text text-start">{{ request.createdDate }}</td>
                  <td class="table-data-text text-start">{{ request.companyName }}</td>
                  <td class="table-data-text text-start">{{ request.authContactFirstName + ' ' +
                    request.authContactLastName }}</td>
                  <td class="table-data-text text-start">LKR {{ request.rollOverAmount | number:'1.2-2' }}</td>
                  <td class="table-data-text text-start">{{ request.rollOverDay }}</td>
                  <td class="table-data-text text-center">
                    <!-- REMOVED data-bs attributes -->
                    <button class="btn p-0" style="background: none; border: none;"
                      (click)="openRequestView(request)">
                      <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <!-- <app-paginator [dataSource]="filteredRolloverRequests" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onRolloverRequestsPageChange($event)">
            </app-paginator> -->
            <app-paginator [serverSide]="true" [totalItems]="totalRequests" [pageSize]="requestPageSize"
              [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onRolloverRequestsPageChange($event)">
            </app-paginator>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<!-- Rollover Request Offcanvas - REMOVED data-bs attributes from div -->
<div #rolloverRequestOffCanvasEl class="offcanvas offcanvas-end w-80" tabindex="-1" id="userFormOffcanvas"
  aria-labelledby="userFormOffcanvasLabel">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">

        <!-- Title with Icon -->
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="userFormOffcanvasLabel">
            <i class="bi fs-5 bi-person-plus"></i>
            Rollover Request
          </h5>
        </div>

        <!-- Close Button -->
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" (click)="closeRequestViewOffcanvas()" aria-label="Close"></span>
        </div>

      </div>
    </div>
  </div>


  <div class="offcanvas-body">
    <form [formGroup]="requestViewForm">
      <div class="row">

        <!-- Left Column: Identifiers and Statuses -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="label-text">Company ID</label>
            <input type="number" formControlName="companyId" class="form-control rounded-pill shadow-none input-text"
              readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Total Earned Wage Withdrawal</label>
            <input type="number" formControlName="totalDueAmount"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Roll Over Percentage (%)</label>
            <input type="number" formControlName="rollOverPercentage"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Roll Over Amount</label>
            <input type="number" formControlName="rollOverAmount"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Rollover Due Date</label>
            <input type="date" formControlName="rolloverDueDate"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Created Date</label>
            <input type="date" formControlName="createdDate" class="form-control rounded-pill shadow-none input-text"
              readonly />
          </div>
          <div class="mb-3" hidden>
            <label class="label-text">Extension ID</label>
            <input type="text" formControlName="extensionId" class="form-control rounded-pill shadow-none input-text"
              readonly />
          </div>
        </div>

        <!-- Right Column: Company Info and Financial Details -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="label-text">Company Name</label>
            <input type="text" formControlName="companyName" class="form-control rounded-pill shadow-none input-text"
              readonly />
          </div>

          <div class="mb-3">
            <label class="label-text">As Of Date</label>
            <input type="date" formControlName="originalDueDate"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
          <div class="mb-3">
            <label class="label-text">Roll Over Day Count</label>
            <input type="number" formControlName="rollOverDay" class="form-control rounded-pill shadow-none input-text"
              readonly />
          </div>


          <div class="mb-3">
            <label class="label-text">Non Roll Over Amount</label>
            <input type="number" formControlName="nonRollOverAmount"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>

          <div class="mb-3">
            <label class="label-text">Roll Over Fee Amount</label>
            <input type="number" formControlName="rollOverFeeAmount"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>

          <div class="mb-3">
            <label class="label-text">Immediate Payable Amount</label>
            <input type="number" formControlName="immediatePayableAmount"
              class="form-control rounded-pill shadow-none input-text" readonly />
          </div>
        </div>
      </div>

      <hr />

      <!-- Action Buttons -->
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-success me-2" (click)="ApproveRequest()" *ngIf="authService.canReview('creditRisk.manageRollovers')">
          <i class="bi bi-check-circle me-2"></i> Approve
        </button>
        <button type="button" class="btn btn-danger" (click)="RejectRequest()" *ngIf="authService.canReview('creditRisk.manageRollovers')">
          <i class="bi bi-x-circle me-2"></i> Reject
        </button>
      </div>
    </form>



  </div>
</div>

<!-- Rollover Profile - Full View Offcanvas - REMOVED data-bs attributes from div -->
<div #rolloverProfileOffcanvasEl class="offcanvas offcanvas-end w-100 w-lg-75" tabindex="-1"
  id="rolloverProfileOffcanvas" aria-labelledby="rolloverProfileOffcanvasLabel">

  <div class="offcanvas-header">
    <div class="d-flex align-items-center gap-2">
      <i class="bi bi-arrow-clockwise fs-5"></i>
      <div>
        <h5 class="offcanvas-title mb-0" id="rolloverProfileOffcanvasLabel">
          Rollover Profile — {{ selectedRolloverProfile?.companyName || '-' }}
        </h5>
        <small class="text-muted">
          CIXOR Ref: {{ selectedRolloverProfile?.cixorReferenceNumber || '-' }}
        </small>
      </div>
    </div>
    <button type="button" class="btn-close text-reset" (click)="closeRolloverProfileOffcanvas()" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">
    <!-- Loading skeleton -->
    <ng-container *ngIf="profileLoading">
      <div class="row g-3">
        <!-- Left column skeleton -->
        <div class="col-lg-8">
          <!-- Basic Rollover Details -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="row">
              <div class="col-sm-6 skeleton-gap-2">
                <div class="skeleton-line w-75"></div>
                <div class="skeleton-line w-50"></div>
                <div class="skeleton-line w-60"></div>
                <div class="skeleton-line w-40"></div>
              </div>
              <div class="col-sm-6 skeleton-gap-2">
                <div class="skeleton-line w-50"></div>
                <div class="skeleton-line w-75"></div>
                <div class="skeleton-line w-60"></div>
                <div class="skeleton-line w-40"></div>
              </div>
            </div>
          </div>

          <!-- Company Details -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
              <div class="skeleton-line w-60"></div>
            </div>
          </div>

          <!-- Payment Details -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-50"></div>
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-25"></div>
            </div>
          </div>

          <!-- Authorization Details -->
          <div class="skeleton-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2 mb-3">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
            </div>
          </div>
        </div>

        <!-- Right column skeleton -->
        <div class="col-lg-4">
          <!-- Status Badge -->
          <div class="skeleton-card text-center mb-3">
            <div class="d-flex justify-content-center">
              <div class="skeleton-rect w-50"></div>
            </div>
          </div>

          <!-- Contact Info -->
          <div class="skeleton-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-50"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-100"></div>
              <div class="skeleton-line w-75"></div>
            </div>
          </div>

          <!-- Dates -->
          <div class="skeleton-card">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="skeleton-line lg w-25"></div>
              <div class="skeleton-badge"></div>
            </div>
            <div class="skeleton-gap-2">
              <div class="skeleton-line w-75"></div>
              <div class="skeleton-line w-50"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Error -->
    <div *ngIf="!profileLoading && profileError" class="text-danger">{{ profileError }}</div>

    <!-- Actual content -->
    <ng-container *ngIf="!profileLoading && !profileError && selectedRolloverProfile as p">
      <div class="row g-3">
        <!-- Left column -->
        <div class="col-lg-8">
          <!-- Basic Rollover Details -->
          <div class="card shadow-sm border-0 mb-3 info-card-glow">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="card-title mb-0">
                  <i class="bi bi-info-circle me-2"></i>
                  Basic Rollover Details
                </h6>
                <span class="badge bg-light text-dark">ID: {{ p.companyRollOverId }}</span>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Total Due Amount</label>
                    <p class="mb-0 fw-medium">{{ p.totalDueAmount | currency:'LKR ':'symbol':'1.2-2' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Roll Over Amount</label>
                    <p class="mb-0 fw-medium">{{ p.rollOverAmount | currency:'LKR ':'symbol':'1.2-2' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Non Roll Over Amount</label>
                    <p class="mb-0 fw-medium">{{ p.nonRollOverAmount | currency:'LKR ':'symbol':'1.2-2' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Roll Over Fee Amount</label>
                    <p class="mb-0 fw-medium">{{ p.rollOverFeeAmount | currency:'LKR ':'symbol':'1.2-2' }}</p>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Immediate Payable Amount</label>
                    <p class="mb-0 fw-medium">{{ p.immediatePayableAmount | currency:'LKR ':'symbol':'1.2-2' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Roll Over Percentage</label>
                    <p class="mb-0 fw-medium">{{ p.rollOverPercentage }}%</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Roll Over Days</label>
                    <p class="mb-0 fw-medium">{{ p.rollOverDays }} days</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Is Paid</label>
                    <p class="mb-0">
                      <span class="badge" [ngClass]="p.isPaid ? 'bg-success' : 'bg-warning'">{{ p.isPaid ? 'Yes' : 'No'
                        }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Company Details -->
          <div class="card shadow-sm border-0 mb-3 info-card-glow">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="card-title mb-0">
                  <i class="bi bi-building me-2"></i>
                  Company Details
                </h6>
                <span class="badge bg-light text-dark">Company ID: {{ p.companyId }}</span>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Company Name</label>
                    <p class="mb-0 fw-medium">{{ p.companyName }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Operating Address</label>
                    <p class="mb-0 fw-medium">{{ p.operatingAddress || 'Not provided' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Legal Type</label>
                    <p class="mb-0 fw-medium">{{ p.legalType || 'Not provided' }}</p>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Email</label>
                    <p class="mb-0 fw-medium">{{ p.email || 'Not provided' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Authorization Details -->
          <div class="card shadow-sm border-0 info-card-glow">
            <div class="card-body">
              <h6 class="card-title mb-3">
                <i class="bi bi-check-circle me-2"></i>
                Authorization Details
              </h6>
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Status</label>
                    <p class="mb-0">
                      <span class="badge bg-success">{{ p.authorizationStatus }}</span>
                    </p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Is Approved</label>
                    <p class="mb-0">
                      <span class="badge" [ngClass]="p.isApproved ? 'bg-success' : 'bg-secondary'">{{ p.isApproved ?
                        'Yes' : 'No' }}</span>
                    </p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Is Active</label>
                    <p class="mb-0">
                      <span class="badge" [ngClass]="p.isActive ? 'bg-success' : 'bg-warning'">{{ p.isActive ? 'Yes' :
                        'No' }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Authorized On</label>
                    <p class="mb-0 fw-medium">{{ p.authorizedOn | date: 'yyyy-MM-dd' }}</p>
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold text-muted small">Created Date</label>
                    <p class="mb-0 fw-medium">{{ p.createdDate | date: 'yyyy-MM-dd' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right column -->
        <div class="col-lg-4">
          <!-- Status Overview -->
          <div class="card shadow-sm border-0 text-center mb-3 info-card-glow">
            <div class="card-body">
              <div class="mb-2">
                <span class="badge fs-6" [ngClass]="p.isPaid ? 'bg-success' : 'bg-warning'">{{ p.isPaid ? 'Paid' :
                  'Pending' }}</span>
              </div>
              <h4 class="text-primary mb-0">{{ p.immediatePayableAmount | currency:'LKR ':'symbol':'1.2-2' }}</h4>
              <small class="text-muted">Immediate Payable</small>
            </div>
          </div>

          <!-- Contact Info -->
          <div class="card shadow-sm border-0 mb-3 info-card-glow">
            <div class="card-body">
              <h6 class="card-title mb-3">
                <i class="bi bi-telephone me-2"></i>
                Contact Info
              </h6>
              <div class="mb-2" *ngIf="p.landlineNumber">
                <label class="form-label fw-semibold text-muted small">Landline</label>
                <p class="mb-0 fw-medium">{{ p.landlineNumber }}</p>
              </div>
              <div class="mb-2" *ngIf="p.mobileNumber">
                <label class="form-label fw-semibold text-muted small">Mobile</label>
                <p class="mb-0 fw-medium">{{ p.mobileNumber }}</p>
              </div>
            </div>
          </div>

          <!-- Dates -->
          <div class="card shadow-sm border-0 info-card-glow">
            <div class="card-body">
              <h6 class="card-title mb-3">
                <i class="bi bi-calendar me-2"></i>
                Dates
              </h6>
              <div class="mb-2">
                <label class="form-label fw-semibold text-muted small">Original Due Date</label>
                <p class="mb-0 fw-medium">{{ p.originalDueDate | date: 'yyyy-MM-dd' }}</p>
              </div>
              <div class="mb-2">
                <label class="form-label fw-semibold text-muted small">Rollover Due Date</label>
                <p class="mb-0 fw-medium">{{ p.rolloverDueDate | date: 'yyyy-MM-dd' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>